import { render } from "./ThemeSwitch.vue?vue&type=template&id=4b6b29f2&scoped=true"
import script from "./ThemeSwitch.vue?vue&type=script&lang=js"
export * from "./ThemeSwitch.vue?vue&type=script&lang=js"

import "./ThemeSwitch.vue?vue&type=style&index=0&id=4b6b29f2&scoped=true&lang=css"

import exportComponent from "/Users/williamconnell/Desktop/Minilogue Project/xdpatch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6b29f2"]])

export default __exports__